export const merchantDelegationGetters = {
  merchantDelegationFormStatus: (state) => state.merchantDelegationFormStatus,
  merchantDelegationIsEdit: state => state.merchantDelegationIsEdit,
  merchantDelegationSelectedForEdit: state => state.merchantDelegationSelectedForEdit,
};